import { envDomain } from '@/common/contact-selector/utils/domainConfig';

/* eslint-disable */
export default function(params) {
    return new Promise((resolve, reject) => {
        if (params.ids && params.ids.length) {
            _getPeopleDetailByUin({
                uins: params.ids,
                privateRemark:1
            }).then(
                res => {
                    const result = {};
                    if (window.parseInt(res.code) === 0 && res.data && res.data.friends) {
                        res.data.friends.forEach(item => {
                            result[item.uin] = {
                                name: item.privateRemark || item.name,
                                face: item.face
                            };
                        });
                        resolve(result);
                    } else {
                        reject(res);
                    }
                },
                err => {
                    reject(err);
                }
            );
        } else {
            resolve({});
        }
    });
}
function _getPeopleDetailByUin(params) {
    return Vue.prototype.$_sAjax.crossPost(`${envDomain.gateway}/v1/qq/qqDetails`, params);
}
